import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "position-absolute top-50 left-50 right-50 end-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}